export const mathCuttingFunction = (fValue) => {
    //if (Config.main.decimalFormatRemove3Digit) {
        let dValue = fValue.toString().split('.')[0],
            remValue = fValue.toString().split('.')[1];
        if (remValue) {
            //avoids javascript bug: 8.2 * 100 = 819.9999999999999
            if (remValue.length > 1) {
                return parseInt(remValue.substr(0, 2)) === 99 ? parseInt(dValue) + 1 : parseInt(dValue);

            } else {
                return Math.floor(fValue);
            }

        } else {
            return fValue;
        }

    //} else {
    //    return fValue;
    //    //TODO check with web version
    //    //return Math.round(fValue);
    //}
};